import { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Select, Typography } from 'antd'

const { Text } = Typography

// Edits the medical providers a user receives alerts for. Rendered only while
// a user is being edited (keyed on user.id by the parent), so its selection
// state initialises fresh from `initialValue` on each open. Persists on Save.
export default function AlertProvidersModal({
  user = null,
  options = [],
  labelById = {},
  initialValue = [],
  onSave,
  onClose,
}) {
  const [selected, setSelected] = useState(initialValue)
  const [saving, setSaving] = useState(false)

  const handleOk = async () => {
    setSaving(true)
    try {
      await onSave(selected)
    } finally {
      setSaving(false)
    }
  }

  const name = user ? `${user.firstName} ${user.lastName}` : ''

  // Visible list of the pending selection, so users don't need to open the
  // dropdown to review who is selected. Same label source as
  // AlertProvidersCell, with the same fallback for deactivated providers.
  const selectedProviders = selected.map(id => ({
    id,
    label: labelById[id] || 'Inactive provider',
  }))

  return (
    <Modal
      open
      title={`${name} — Receives alerts for`}
      okText="Save"
      confirmLoading={saving}
      onOk={handleOk}
      onCancel={onClose}
    >
      <Select
        mode="multiple"
        allowClear
        style={{ width: '100%' }}
        placeholder="Select medical providers"
        optionFilterProp="label"
        value={selected}
        options={options}
        onChange={setSelected}
      />
      {selectedProviders.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Text type="secondary">Selected ({selectedProviders.length})</Text>
          <ul style={{ margin: '4px 0 0', paddingLeft: 20 }}>
            {selectedProviders.map(provider => (
              <li key={provider.id}>{provider.label}</li>
            ))}
          </ul>
        </div>
      )}
    </Modal>
  )
}

AlertProvidersModal.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
    }),
  ),
  labelById: PropTypes.objectOf(PropTypes.string),
  initialValue: PropTypes.arrayOf(PropTypes.string),
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
